<template>
  <div v-if="loading == true">
    <v-toolbar color="white" dense flat>
      <v-btn
        icon
        @click="getBack()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="body_naja">
      <div class="progress">
        <div class="color"></div>
      </div>
    </div>
  </div>
  <div v-else>
    <v-toolbar dense flat dark>
      <v-btn
        icon
        @click="getBack()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-toolbar-title
        >Order detail #{{ order_detail.order_code }}</v-toolbar-title
      >
      <v-spacer />
    </v-toolbar>
    <v-card class="mt-2">
      <v-card-text>
        <v-layout row wrap>
          <v-flex sm6 xs12>
            <v-card-text>
              <div>
                <div
                  style="
                    font-size: 18px;
                    width: 100%;
                    text-align: center;
                    border-bottom: 1px solid #d9d9d9;
                    line-height: 0.1em;
                    margin: 10px 0 20px;
                    font-weight: bold;
                  "
                >
                  <span style="background: #fff; padding: 0 10px">
                    Order Information</span
                  >
                </div>
                <v-card
                  class="mt-2"
                  flat
                  style="border: 2px solid #e9e9e9; border-radius: 10px"
                >
                  <v-card-text style="font-size: 15px; font-weight: bold">
                    <v-layout wrap>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Order Status :
                        <span
                          style="
                            border-radius: 6px;
                            padding: 0px 10px;
                            color: white;
                            box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
                            white-space: nowrap;
                            font-weight: bold;
                          "
                          :style="{
                            backgroundColor:
                              order_detail.order_status == 3
                                ? '#4bb543'
                                : order_detail.order_status == 4
                                ? 'red'
                                : 'orange',
                          }"
                          >{{
                            order_detail.order_status == 3
                              ? "Completed"
                              : order_detail.order_status == 4
                              ? "Canceled"
                              : "On Process"
                          }}</span
                        ></v-flex
                      >
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Pay by :
                        <span style="color: grey">
                          {{
                            order_detail.order_payment_type == 1
                              ? "COD"
                              : order_detail.order_payment_type == 2
                              ? "Credit/Debit"
                              : order_detail.order_payment_type == 4
                              ? "COIN"
                              : order_detail.order_payment_type == 5
                              ? "AR"
                              : "Other"
                          }}</span
                        >
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Pay status :
                        <span
                          :style="{
                            color:
                              order_detail.order_is_paymented == 1
                                ? 'red'
                                : '#4bb543',
                          }"
                        >
                          {{
                            order_detail.order_is_paymented == 1
                              ? "Unpaid"
                              : "Paid"
                          }}</span
                        >
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Date time Order :
                        <span style="color: grey">
                          {{
                            moment(order_detail.create_at).format(
                              "YYYY-MM-DD HH:mm น."
                            )
                          }}</span
                        >
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Date time Dine in :
                        <span style="color: grey">
                          {{
                            moment
                              .utc(order_detail.order_booking_datetime)
                              .format("YYYY-MM-DD HH:mm น.")
                          }}
                        </span>
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Booking expiration date:
                        <span
                          style="color: grey"
                          v-if="order_detail.order_booking_expried_datetime"
                        >
                          {{
                            moment
                              .utc(order_detail.order_booking_expried_datetime)
                              .format("YYYY-MM-DD")
                          }}</span
                        >
                        <span style="color: grey" v-else>-</span>
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Order note :
                        <span
                          style="color: grey"
                          v-if="order_detail.order_note"
                        >
                          {{ order_detail.order_note }}
                        </span>
                        <span style="color: grey" v-else>-</span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </div>
              <div class="mt-5">
                <div
                  style="
                    font-size: 18px;
                    width: 100%;
                    text-align: center;
                    border-bottom: 1px solid #d9d9d9;
                    line-height: 0.1em;
                    margin: 10px 0 20px;
                    font-weight: bold;
                  "
                >
                  <span style="background: #fff; padding: 0 10px">
                    Customer Information</span
                  >
                </div>
                <v-card
                  class="mt-2"
                  flat
                  style="border: 2px solid #e9e9e9; border-radius: 10px"
                >
                  <v-card-text style="font-size: 15px; font-weight: bold">
                    <v-layout wrap>
                      <v-flex xs12>
                        Full name :
                        <span style="color: grey">
                          {{ order_detail.order_customer_name }}</span
                        >
                      </v-flex>
                      <v-flex xs12>
                        Tel. :
                        <span style="color: grey">
                          {{ order_detail.order_customer_tel }}</span
                        >
                      </v-flex></v-layout
                    >
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-flex>
          <v-flex sm6 xs12>
            <v-card-text>
              <div>
                <div
                  style="
                    font-size: 18px;
                    width: 100%;
                    text-align: center;
                    border-bottom: 1px solid #d9d9d9;
                    line-height: 0.1em;
                    margin: 10px 0 20px;
                    font-weight: bold;
                  "
                >
                  <span style="background: #fff; padding: 0 10px">
                    Store Information</span
                  >
                </div>
                <v-card
                  flat
                  style="border: 2px solid #e9e9e9; border-radius: 10px"
                >
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 class="mt-2">
                        <div style="font-size: 15px; font-weight: bold">
                          <label class="mr-1">Store name :</label>
                          <span style="color: grey">
                            {{ order_detail.order_store.store_name }}
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 class="mt-2">
                        <div
                          style="
                            display: flex;
                            font-size: 15px;
                            font-weight: bold;
                          "
                        >
                          <label class="mr-1">Store Tel. :</label>
                          <span style="color: grey">
                            {{ order_detail.order_store.store_tel }}
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 class="mt-2">
                        <div style="font-size: 15px; font-weight: bold">
                          <div class="mr-1">Address :</div>
                          <div style="color: grey">
                            {{ order_detail.order_store.store_addr }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs12 lg6 class="mt-2">
                        <div
                          style="
                            display: flex;
                            font-size: 15px;
                            font-weight: bold;
                          "
                        >
                          <label class="mr-1">Latitude :</label>
                          <span style="color: grey">
                            {{ order_detail.order_store.store_lat }}
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 lg6 class="mt-2">
                        <div
                          style="
                            display: flex;
                            font-size: 15px;
                            font-weight: bold;
                          "
                        >
                          <label class="mr-1">Longitude :</label>
                          <span style="color: grey">
                            {{ order_detail.order_store.store_long }}
                          </span>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-space-between class="mt-3">
                      <v-flex class="mt-3 text-xs-center">
                        <v-btn
                          outline
                          :href="`https://www.google.co.th/maps/dir/${order_detail.order_store.store_lat},${order_detail.order_store.store_long}/data=!4m2!4m1!3e0`"
                          target="_blank"
                          class="black--text"
                          style="border-radius: 6px"
                        >
                          <v-icon class="mr-1" size="18">mdi-map-marker</v-icon>
                          see location
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-flex>
        </v-layout>
        <div class="mt-4 px-3" v-if="order_detail.order_detail.length > 0">
          <div
            style="
              font-size: 18px;
              width: 100%;
              text-align: center;
              border-bottom: 1px solid #d9d9d9;
              line-height: 0.1em;
              margin: 10px 0 20px;
              font-weight: bold;
            "
          >
            <span style="background: #fff; padding: 0 10px">
              Product Information</span
            >
          </div>
          <v-card
            class="mt-2"
            flat
            style="border: 2px solid #e9e9e9; border-radius: 10px"
          >
            <v-card-text style="font-size: 15px">
              <v-layout wrap>
                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold"> Product name:</span>
                  <span>
                    {{ order_detail.order_detail[0].detail_product_name_th }}
                    <span style="color: grey">
                      ({{
                        order_detail.order_detail[0].detail_product_name_en
                      }})</span
                    ></span
                  >
                </v-flex>
                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold">
                    Description TH :
                  </span></v-flex
                ><v-flex xs12 class="mt-1">
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_description_th
                    }}</span
                  >
                </v-flex>
                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold">
                    Description EN :</span
                  > </v-flex
                ><v-flex xs12 class="mt-1">
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_description_en
                    }}</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Course amount :</span>
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_course_amount
                    }}</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Person :</span>
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_minimum_person
                    }}
                    -
                    {{
                      order_detail.order_detail[0].detail_product_maximum_person
                    }}</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Time limit(minute) :</span>
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_time_limit
                    }}</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Booking expired date :</span>
                  <span style="color: grey">
                    {{
                      moment(
                        order_detail.order_detail[0]
                          .detail_product_booking_expiration
                      ).format("YYYY-MM-DD")
                    }}</span
                  >
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </div>
        <v-divider class="mt-3"></v-divider>
        <div class="mt-4 px-3">
          <div
            style="
              font-size: 18px;
              width: 100%;
              text-align: center;
              font-weight: bold;
            "
          >
            <span
              style="
                background: #fff;
                padding: 0 10px;
                border-bottom: 1px solid black;
              "
            >
              Price Information</span
            >
          </div>
          <v-card class="mt-2" flat>
            <v-card-text
              style="font-size: 15px; display: flex; justify-content: center"
            >
              <div style="width: 80vw; max-width: 600px">
                <table width="100%">
                  <tr style="height: 30px">
                    <td class="text-xs-left">Total price</td>
                    <td width="40%" class="text-xs-right">
                      {{ order_detail.order_sale_price }} THB
                    </td>
                  </tr>
                  <tr style="height: 30px">
                    <td
                      class="text-xs-left"
                      :style="{
                        color: 'red',
                      }"
                    >
                      Discount by WESERVE
                    </td>
                    <td
                      width="40%"
                      class="text-xs-right"
                      :style="{
                        color: 'red',
                      }"
                    >
                      {{ order_detail.order_discount_weserve }} THB
                    </td>
                  </tr>
                  <tr style="height: 30px">
                    <td
                      class="text-xs-left"
                      :style="{
                        color: 'red',
                      }"
                    >
                      Discount by Promotion/Reward
                    </td>
                    <td
                      width="40%"
                      class="text-xs-right"
                      :style="{
                        color: 'red',
                      }"
                    >
                      {{ order_detail.order_discount_by_code }} THB
                    </td>
                  </tr>
                  <tr style="height: 30px">
                    <td
                      class="text-xs-left"
                      :style="{
                        color: 'red',
                      }"
                    >
                      Discount by Store
                    </td>
                    <td
                      width="40%"
                      class="text-xs-right"
                      :style="{
                        color: 'red',
                      }"
                    >
                      {{ order_detail.order_discount_by_store }} THB
                    </td>
                  </tr>
                  <tr style="height: 30px; font-size: 16px; font-weight: bold">
                    <td
                      class="text-xs-left"
                      :style="{
                        color: 'green',
                      }"
                    >
                      Net price
                    </td>
                    <td
                      width="40%"
                      class="text-xs-right"
                      style="font-size: 16px; color: green"
                    >
                      {{ order_detail.order_net_price }} THB
                    </td>
                  </tr>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card>

    <orderLog class="mt-3" :order_detail="order_detail" />
  </div>
</template>

<script>
import orderLog from "@/components/back-office/OrderOnline/OrderDetail/DineIn/OrderLog.vue";
export default {
  components: {
    orderLog,
  },
  data() {
    return {
      canceling_order: false,
      completing: false,
      loading: false,
      date: new Date().toISOString().substr(0, 10),
      order_detail: {
        // order_id: 4,
        // order_code: "DI5SDNV3NYSW",
        // order_customer_id: 41378,
        // order_customer_name: "thanatporn thongchai",
        // order_customer_tel: "+660814797647",
        // order_sale_price: 399,
        // order_net_price: 299,
        // order_discount: 100,
        // order_status: 1,
        // order_payment_type: 2,
        // order_booking_datetime: "2022-12-21T02:30:00Z",
        // order_booking_expired_datetime: "2022-12-31T02:30:00Z",
        // create_at: "2022-12-01T02:30:00Z",
        // order_store: {
        //   store_id: 64,
        //   store_name: "กาแฟหรือแกฟ่ะ",
        //   store_addr: "ภูเก็ต",
        //   store_lat: "7.880338324673776",
        //   store_long: "98.39217356819148",
        //   store_tel: "+66 0814797464",
        // },
        // order_detail: [
        //   {
        //     detail_product: 43,
        //     detail_product_price: 399,
        //     detail_product_quantity: 1,
        //     detail_product_name_th: "เซ็ทเลือกได้ 3 เมนูสำหรับ 2 ท่าน",
        //     detail_product_name_en:
        //       "Sharing Set For 2 Person : Choose 3 Dishes",
        //     detail_product_description_th:
        //       "เซ็ทเลือกได้ 3 เมนูสำหรับ 2 ท่านเช่น ปลาทอดน้ำปลา กุ้งผัดพริกไทยดำ เป็นต้นและรายการอื่นๆอีกมากมาย พร้อมเครื่องดื่มNon Alcohol Drink ไม่อั้น!",
        //     detail_product_description_en:
        //       "Choose 4 Dishes for 2 Person Such as Fried Fish with Fish Sauce, Fried Shrimp with Black Pepper and More Menus with Free Flow Non Alcohol Drink",
        //     detail_product_course_amount: 3,
        //     detail_product_minimum_person: 1,
        //     detail_product_maximum_person: 3,
        //     detail_product_booking_expiration: "2022-12-30T17:00:00Z",
        //     detail_product_time_limit: "150",
        //   },
        // ],
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    getBack() {
      this.$router.back();
    },
    async fetchData() {
      this.loading = true;
      let result = await this.$store.dispatch("fetchDineIn/fetchOrderDetail", {
        order_id: this.$route.params.order_id,
      });
      this.loading = false;
      if (result == false) return;
      this.order_detail = result;
      return;
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>

<style>
.time-picker input.display-time {
  border: none;
}
</style>

<style scoped>
.body_naja {
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
}
.progress {
  position: relative;
  height: 10px;
  width: 1110%;
  border: 10px solid #f4a261;
  border-radius: 15px;
  display: flex;
  align-items: center;
}
.progress .color {
  position: absolute;
  background-color: #ffffff;
  width: 0px;
  height: 10px;
  border-radius: 15px;
  animation: progres 0.5s infinite linear;
}

@keyframes progres {
  0% {
    width: 0%;
  }
  25% {
    width: 50%;
  }
  50% {
    width: 75%;
  }
  75% {
    width: 85%;
  }
  100% {
    width: 100%;
  }
}
</style>
